import { useMemo } from 'react'
import isEmpty from 'lodash/isEmpty'

// Pure version of the hook's rule, usable outside components (e.g. to filter
// a list of nav items before rendering them). Empty `authority` or empty
// `userAuthority` means "no restriction" unless `emptyCheck` is set.
export function hasAuthority(
    userAuthority = [],
    authority = [],
    emptyCheck = false
) {
    if (
        isEmpty(authority) ||
        isEmpty(userAuthority) ||
        typeof authority === 'undefined'
    ) {
        return !emptyCheck
    }
    return authority.some((role) => userAuthority.includes(role))
}

function useAuthority(userAuthority = [], authority = [], emptyCheck = false) {
    return useMemo(
        () => hasAuthority(userAuthority, authority, emptyCheck),
        [authority, userAuthority, emptyCheck]
    )
}

export default useAuthority
